import React, { useEffect, useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import "./BlogPage.css";

import BlogImg1 from "../../assets/blog/blogImg1.png";
import BlogImg2 from "../../assets/blog/blogImg2.png";
import BlogImg3 from "../../assets/blog/blogImg3.png";
import BlogImg4 from "../../assets/blog/blogImg4.png";
import BlogImg5 from "../../assets/blog/blogImg5.png";
import BlogImg6 from "../../assets/blog/blogImg6.png";

import Newsletter from "../../components/blogs/Newsletter";

const blogData = [
  {
    id: 1,
    title: "A Guide to Mastering Investment Tracking",
    image: BlogImg1,
    slug: "a-guide-to-mastering-investment-tracking",
  },
  {
    id: 2,
    title: "Start Planning for Retirement Today",
    image: BlogImg2,
    slug: "start-planning-for-retirement-today",
  },
  {
    id: 3,
    title: "Regain Control with Debt Management",
    image: BlogImg3,
    slug: "regain-control-with-debt-management",
  },
  {
    id: 4,
    title: "Optimizing Strategies for Financial Growth",
    image: BlogImg4,
    slug: "optimizing-strategies-for-financial-growth",
  },
  {
    id: 5,
    title: "Stay Informed with Real-Time Updates",
    image: BlogImg5,
    slug: "stay-informed-with-real-time-updates",
  },
  {
    id: 6,
    title: "Diversify and Prosper with Portfolio Management",
    image: BlogImg6,
    slug: "diversify-and-prosper-with-portfolio-management",
  },
];

const BlogPage = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const items = entry.target.querySelectorAll(".reveal-item");

            items.forEach((el, i) => {
              setTimeout(() => {
                el.classList.add("reveal-visible");
              }, i * 120);
            });

            observer.disconnect();
          }
        });
      },
      { threshold: 0.2 },
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
  }, []);

  return (
    <div ref={sectionRef} className="blog-page-wrapper">
      <section className="blog-hero-section">
        <div className="blog-container">
          {/* Header */}
          <div className="blog-header reveal-item">
            <span className="blog-badge">FROM OUR BLOG</span>
            <h1 className="blog-title">
              Our latest insight & <br /> update
            </h1>
          </div>

          {/* Blog Grid */}
          <div className="blog-grid">
            {blogData.map((blog) => (
              <Link
                key={blog.id}
                to={`/blog/${blog.slug}`}
                className="blog-card reveal-item"
                onClick={() => window.scrollTo(0, 0)}
              >
                <div className="blog-img-wrapper">
                  <img src={blog.image} alt={blog.title} className="blog-img" />
                  <div className="blog-gradient-overlay"></div>
                </div>

                <div className="blog-content">
                  <h3 className="blog-card-title">{blog.title}</h3>
                  <ArrowUpRight className="blog-card-icon" size={20} />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Newsletter />
    </div>
  );
};

export default BlogPage;
